import React from 'react';

import { PetitionCard } from '@change/ds-core-ui/PetitionCard';

import { stripHtmlTags } from '@change-corgi/core/html';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useHitCard } from './hooks/useHitCard';
import type { HitProps } from './types';

export const HitCard: React.FC<HitProps> = ({ hit }: HitProps) => {
	const {
		data: { createdAtLocalized, petitionUrl, imageUrl, signaturesCount, signaturesCountLocalized, locationName },
		actions: { trackPetitionCardClick },
	} = useHitCard({ hit });
	const { translate, translatePlural } = useI18n();

	return (
		<PetitionCard
			body={stripHtmlTags(hit.description)}
			imageUrl={imageUrl}
			location={locationName || ''}
			orientation="horizontal"
			petitionId={hit.id}
			petitionLinkOnClick={() => {
				trackPetitionCardClick();
			}}
			petitionLinkUrl={petitionUrl}
			signaturesLabel={translatePlural('corgi.components.petition_card.signatures', signaturesCount, {
				countLocalized: signaturesCountLocalized,
			})}
			title={hit.ask}
			isVictory={hit.status === 'victory'}
			startedLabel={translate('corgi.components.petition_card.created_at', {
				date: createdAtLocalized,
			})}
			victoryLabel={translate('corgi.components.petition_card.victory')}
			data-qa="petition-card"
		/>
	);
};
